export const getIsCloseChatLoading = state => state.chats.isCloseChatLoading;
